import Vue from "vue";
import moment from "moment";

export default {
  name: "powngan-productions",
  data: function () {
    return {
      keyword: "",
      keyword_side: null, // null=ทั้งหมด | 'producer'=ถูกโป๊วมา | 'owner'=ไปโป๊วคนอื่น
      busy: false,
      items: [],
      totalItem: 0,
      perPage: 20,
      currentPage: 1,
      apiStatus: "ไม่พบข้อมูล",
      fields: [
        {
          key: "document_no",
          label: "เลขที่ใบผลิต",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "powngan",
          label: "อ้างอิงใบสั่งโป๊ว (เจ้าของงาน → ผู้ผลิต)",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_length",
          label: "ความยาวรวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
        {
          key: "creator_detail.name",
          label: "ผู้ออกใบผลิต",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
      ],
    };
  },
  mounted() {
    this.onInitData(1);
  },
  methods: {
    formatDate(d) {
      return d ? moment(d).format("DD/MM/YYYY") : "-";
    },
    formatMoney(n) {
      return (Number(n) || 0).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    async onInitData(page) {
      try {
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";
        const url = `${Vue.prototype.$host}/api/v1/document/powngan-productions?page=${page || 1}&keyword=${encodeURIComponent(this.keyword || "")}&keyword_side=${encodeURIComponent(this.keyword_side || "")}`;
        const result = await Vue.prototype.$axios.get(url);
        this.items = result.data.data || [];
        this.totalItem = result.data.total || 0;
        this.currentPage = page || 1;
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler(error?.response?.data?.message);
      }
    },
    async generatePDF(uuid) {
      try {
        const result = await this.$axios.get(
          `${Vue.prototype.$host}/api/v1/document/powngan-productions/${uuid}/pdf`,
          { responseType: "blob" }
        );
        const blob = new Blob([result.data], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl, "targetWindow", "width=900,height=700");
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message);
      }
    },
  },
};
